export default __webpack_public_path__ + "static/media/marseille-2x.876df7a3.webp";